import Model from '@/lib/data/Model';

class Underwriter extends Model {
    static idProperty = 'id';

    fields = [
        { name: 'id' },
        { name: 'uw_name' },
        { name: 'uw_surname' },
        { name: 'record_state', type: 'int', defaultValue: 1 },
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    get fullName() {
        return `${this.uw_name} ${this.uw_surname}`;
    }
}

export default Underwriter;
